import script from "./RfidFoldingTicketOrderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidFoldingTicketOrderPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidFoldingTicketOrderPage.vue?vue&type=style&index=0&id=3731d100&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3731d100"]])

export default __exports__